import React from "react";
import { Box, Typography } from "@mui/material";
import { useLocation } from "react-router-dom";
import { useTenant } from "../contexts/TenantContext";
import StandardCoursesView from "./globalAdmin/standardCourses/StandardCoursesView";

/** Standalone page for building, publishing and retiring standard courses. Global admins only. */
export default function StandardCoursesPage() {
  const { user } = useTenant();
  const initialView = new URLSearchParams(useLocation().search).get("view") === "catalog" ? "catalog" : "courses";
  const isGlobalAdmin = !!user?.roles?.includes("GLOBAL_ADMIN");

  if (!isGlobalAdmin) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography>You don't have access to Standardize Courses.</Typography>
      </Box>
    );
  }

  return (
    <Box className="ga-root" data-testid="standard-courses-page">
      <div className="ga-page-main">
        <StandardCoursesView initialView={initialView} />
      </div>
    </Box>
  );
}
